const DEFAULT_COLUMNS = [
  {
    Header: "Linea",
    id: "key",
    type: "number",
    accessor: "Line",
  },
  {
    Header: "Nombre",
    id: "Response",
    type: "Text",
    accessor: "Name",
  },
  {
    Header: "Cantidad",
    type: "number",
    accessor: "Quantity",
  },
  {
    Header: "Unidad de medida",
    id: "measurementUnit",
    type: "Text",
    accessor: "MeasurementUnit",
  },
  {
    Header: "Detalle",
    id: "detail",
    type: "Text",
    accessor: "Detail",
  },
  {
    Header: "Descuento",
    id: "discount",
    type: "Text",
    accessor: "Discount",
  },
  {
    Header: "IVA",
    id: "iva",
    type: "Text",
    accessor: "Iva",
  },
  {
    Header: "Precio Unitario",
    type: "number",
    accessor: "UnitPrice",
  },
  {
    Header: "Subtotal",
    id: "subtotal",
    type: "number",
    accessor: "Subtotal",
  },
  {
    Header: "Total",
    type: "number",
    accessor: "Amount",
  },
];

export default DEFAULT_COLUMNS;
